module.exports = __webpack_public_path__ + "static/front/img/ship_icon_2.9818e1ed.png";